import Logo from './Logo.svg'
import LogoIcon from './LogoIcon.svg'
import LogoBackground from './LogoBackground.svg'
import NavBarBg from './NavBarLarge.svg'
import NavBarLarge from './NavBarLarge.svg'
import NavBarMobile from './NavBarMobile.svg'
import FooterLogo from './FooterLogo.svg'
import FeatureCardLogo from './LandingPage/FeatureCardLogo.svg'
import Feature1 from './LandingPage/OpenKitchen.jpg'
import Feature2 from './LandingPage/EuropeanRecipes.jpg'
import Feature3 from './LandingPage/FreshIngredients.jpg'
import FeatureSectionShape from './LandingPage/Shape.svg'
import Category1 from './LandingPage/Categories/Breakfast.png'
import Category2 from './LandingPage/Categories/Salads.jpg'
import Category3 from './LandingPage/Categories/Sandwiches.png'
import Category4 from './LandingPage/Categories/SavoryPies.png'
import Category5 from './LandingPage/Categories/Pasta.jpg'
import Category6 from './LandingPage/Categories/Mains.jpg'
import Category7 from './LandingPage/Categories/Viennoiserie.jpg'
import Category8 from './LandingPage/Categories/DanishPastries.jpg'
import Category9 from './LandingPage/Categories/Artisans.jpg'
import Category10 from './LandingPage/Categories/PiesTarts.jpg'
import Category11 from './LandingPage/Categories/Cakes.jpg'
import Category12 from './LandingPage/Categories/Cupcakes.jpg'
import Category13 from './LandingPage/Categories/Cookies.png'
import Category14 from './LandingPage/Categories/Bombolones.jpg'
import Category15 from './LandingPage/Categories/Cheesecakes.jpg'
import Category16 from './LandingPage/Categories/ChilledDesserts.jpg'
import Category17 from './LandingPage/Categories/TresLeches.jpg'
import Category18 from './LandingPage/Categories/Gelato.jpg'
import Category19 from './LandingPage/Categories/Coffee.jpg'
import Category20 from './LandingPage/Categories/Smoothies.jpg'
import Category21 from './LandingPage/Categories/Mocktails.jpg'
import Category22 from './LandingPage/Categories/SoftDrinks.png'
import RatedProduct1 from './LandingPage/Rated Products/MixedBerryVanilaPie.png'
import RatedProduct2 from './LandingPage/Rated Products/BeefCheekAndMushroom.png'
import RatedProduct3 from './LandingPage/Rated Products/AcaiBowl.png'
import AboutHeroImage from './AboutPage/AboutHeroImage.jpg'
import Team from './AboutPage/Team.jpg'
import FavItem1 from './CategoryPage/FavItem1.jpg'
import FavItem2 from './CategoryPage/FavItem2.jpg'
import CategoryPageBackground from './CategoryPage/CategoryPageBackground.svg'
import ArtisansHeroImage from './CategoryPage/Categories/Artisans/Hero.jpg'
import Artisan1 from './CategoryPage/Categories/Artisans/Artisan1.jpg'
import Artisan2 from './CategoryPage/Categories/Artisans/Artisan2.jpg'
import Artisan3 from './CategoryPage/Categories/Artisans/Artisan3.jpg'
import Artisan4 from './CategoryPage/Categories/Artisans/Artisan4.jpg'
import Artisan5 from './CategoryPage/Categories/Artisans/Artisan5.jpg'
import BombolonesHeroImage from './CategoryPage/Categories/Bombolones/Hero.jpg'
import Bombolone1 from './CategoryPage/Categories/Bombolones/Bombolone1.jpg'
import Bombolone2 from './CategoryPage/Categories/Bombolones/Bombolone2.jpg'
import Bombolone3 from './CategoryPage/Categories/Bombolones/Bombolone3.jpg'
import BreakfastHeroImage from './CategoryPage/Categories/Breakfast/Hero.jpg'
import Breakfast1 from './CategoryPage/Categories/Breakfast/Breakfast1.jpg'
import Breakfast2 from './CategoryPage/Categories/Breakfast/Breakfast2.jpg'
import Breakfast3 from './CategoryPage/Categories/Breakfast/Breakfast3.jpg'
import CakesHeroImage from './CategoryPage/Categories/Cakes/Hero.jpg'
import Cake1 from './CategoryPage/Categories/Cakes/Cake1.jpg'
import Cake2 from './CategoryPage/Categories/Cakes/Cake2.jpg'
import Cake3 from './CategoryPage/Categories/Cakes/Cake3.jpg'
import CheesecakeHeroImage from './CategoryPage/Categories/Cheesecakes/Hero.jpg'
import Cheesecake1 from './CategoryPage/Categories/Cheesecakes/Cheesecake1.jpg'
import Cheesecake2 from './CategoryPage/Categories/Cheesecakes/Cheesecake2.jpg'
import ChilledDessertHeroImage from './CategoryPage/Categories/Chilled Desserts/Hero.jpg'
import ChilledDessert1 from './CategoryPage/Categories/Chilled Desserts/ChilledDessert1.jpg'
import ChilledDessert2 from './CategoryPage/Categories/Chilled Desserts/ChilledDessert2.jpg'
import ChilledDessert3 from './CategoryPage/Categories/Chilled Desserts/ChilledDessert3.jpg'
import ChilledDessert4 from './CategoryPage/Categories/Chilled Desserts/ChilledDessert4.jpg'
import CookiesHeroImage from './CategoryPage/Categories/Cookies/Hero.jpg'
import Cookie1 from './CategoryPage/Categories/Cookies/Cookie1.png'
import Cookie2 from './CategoryPage/Categories/Cookies/Cookie2.png'
import Cookie3 from './CategoryPage/Categories/Cookies/Cookie3.jpg'
import Cookie4 from './CategoryPage/Categories/Cookies/Cookie4.png'
import CupcakesHeroImage from './CategoryPage/Categories/Cupcakes/Hero.jpg'
import Cupcake1 from './CategoryPage/Categories/Cupcakes/Cupcake1.jpg'
import Cupcake2 from './CategoryPage/Categories/Cupcakes/Cupcake2.jpg'
import Cupcake3 from './CategoryPage/Categories/Cupcakes/Cupcake3.jpg'
import Cupcake4 from './CategoryPage/Categories/Cupcakes/Cupcake4.jpg'
import Cupcake5 from './CategoryPage/Categories/Cupcakes/Cupcake5.jpg'
import GrillsHeroImage from './CategoryPage/Categories/Grills/Hero.jpg'
import Grill1 from './CategoryPage/Categories/Grills/Grill1.jpg'
import Grill2 from './CategoryPage/Categories/Grills/Grill2.jpg'
import Grill3 from './CategoryPage/Categories/Grills/Grill3.jpg'
import PastaHeroImage from './CategoryPage/Categories/Pasta/Hero.jpg'
import Pasta1 from './CategoryPage/Categories/Pasta/Pasta1.jpg'
import Pasta2 from './CategoryPage/Categories/Pasta/Pasta2.jpg'
import Pasta3 from './CategoryPage/Categories/Pasta/Pasta3.jpg'
import PiesTartsHeroImage from './CategoryPage/Categories/Pies & Tarts/Hero.jpg'
import Pie1 from './CategoryPage/Categories/Pies & Tarts/SweetPie1.jpg'
import Pie2 from './CategoryPage/Categories/Pies & Tarts/SweetPie2.jpg'
import SaladsHeroImage from './CategoryPage/Categories/Salads/Hero.jpg'
import Salad1 from './CategoryPage/Categories/Salads/Salad1.jpg'
import Salad2 from './CategoryPage/Categories/Salads/Salad2.jpg'
import Salad3 from './CategoryPage/Categories/Salads/Salad3.jpg'
import SandwichesHeroImage from './CategoryPage/Categories/Sandwiches/Hero.jpg'
import Sandwich1 from './CategoryPage/Categories/Sandwiches/Sandwich1.jpg'
import Sandwich2 from './CategoryPage/Categories/Sandwiches/Sandwich2.jpg'
import Sandwich3 from './CategoryPage/Categories/Sandwiches/Sandwich3.jpg'
import SavoryPiesHeroImage from './CategoryPage/Categories/Savory Pies/Hero.png'
import SavoryPie1 from './CategoryPage/Categories/Savory Pies/SavoryPie1.jpg'
import SavoryPie2 from './CategoryPage/Categories/Savory Pies/SavoryPie2.jpg'
import ViennoiserieHeroImage from './CategoryPage/Categories/Viennoiserie/Hero.jpg'
import Viennoiserie1 from './CategoryPage/Categories/Viennoiserie/Viennoiserie1.jpg'
import Viennoiserie2 from './CategoryPage/Categories/Viennoiserie/Viennoiserie2.jpg'
import Viennoiserie3 from './CategoryPage/Categories/Viennoiserie/Viennoiserie3.jpg'
import DanishPastriesHeroImage from './CategoryPage/Categories/Danish Pastries/Hero.jpg'
import DanishPastrie1 from './CategoryPage/Categories/Danish Pastries/DanishPastrie1.jpg'
import DanishPastrie2 from './CategoryPage/Categories/Danish Pastries/DanishPastrie2.jpg'
import DanishPastrie3 from './CategoryPage/Categories/Danish Pastries/DanishPastrie3.jpg'
import TresLechesHeroImage from './CategoryPage/Categories/Tres Leches/Hero.jpg'
import TresLeches1 from './CategoryPage/Categories/Tres Leches/TresLeches1.jpg'
import TresLeches2 from './CategoryPage/Categories/Tres Leches/TresLeches2.jpg'
import TresLeches3 from './CategoryPage/Categories/Tres Leches/TresLeches3.jpg'
import TresLeches4 from './CategoryPage/Categories/Tres Leches/TresLeches4.jpg'
import TresLeches5 from './CategoryPage/Categories/Tres Leches/TresLeches5.jpg'
import GelatoHeroImage from './CategoryPage/Categories/Gelato/Hero.jpg'
import Gelato1 from './CategoryPage/Categories/Gelato/Gelato1.jpg'
import Gelato2 from './CategoryPage/Categories/Gelato/Gelato2.jpg'
import Gelato3 from './CategoryPage/Categories/Gelato/Gelato3.jpg'
import Gelato4 from './CategoryPage/Categories/Gelato/Gelato4.jpg'
import Gelato5 from './CategoryPage/Categories/Gelato/Gelato5.jpg'
import Gelato6 from './CategoryPage/Categories/Gelato/Gelato6.jpg'
import CoffeeHeroImage from './CategoryPage/Categories/Coffee/Hero.jpg'
import HotCoffee1 from './CategoryPage/Categories/Coffee/HotCoffee1.jpg'
import HotCoffee2 from './CategoryPage/Categories/Coffee/HotCoffee2.jpg'
import HotCoffee3 from './CategoryPage/Categories/Coffee/HotCoffee3.jpg'
import HotCoffee4 from './CategoryPage/Categories/Coffee/HotCoffee4.jpg'
import HotCoffee5 from './CategoryPage/Categories/Coffee/HotCoffee5.jpg'
import HotCoffee6 from './CategoryPage/Categories/Coffee/HotCoffee6.jpg'
import HotCoffee7 from './CategoryPage/Categories/Coffee/HotCoffee7.jpg'
import HotCoffee8 from './CategoryPage/Categories/Coffee/HotCoffee8.jpg'
import HotCoffee9 from './CategoryPage/Categories/Coffee/HotCoffee9.jpg'
import HotCoffee10 from './CategoryPage/Categories/Coffee/HotCoffee10.jpg'
import HotCoffee11 from './CategoryPage/Categories/Coffee/HotCoffee11.jpg'
import HotCoffee12 from './CategoryPage/Categories/Coffee/HotCoffee12.jpg'
import ColdBrew1 from './CategoryPage/Categories/Coffee/ColdBrew1.jpg'
import ColdBrew2 from './CategoryPage/Categories/Coffee/ColdBrew2.jpg'
import HotTea1 from './CategoryPage/Categories/Coffee/HotTea1.jpeg'
import HotTea2 from './CategoryPage/Categories/Coffee/HotTea2.jpg'
import HotTea3 from './CategoryPage/Categories/Coffee/HotTea3.jpg'
import HotTea4 from './CategoryPage/Categories/Coffee/HotTea4.jpg'
import HotTea5 from './CategoryPage/Categories/Coffee/HotTea5.jpg'
import HotTea6 from './CategoryPage/Categories/Coffee/HotTea6.jpg'
import HotTea7 from './CategoryPage/Categories/Coffee/HotTea7.jpg'
import IcedTea1 from './CategoryPage/Categories/Coffee/IcedTea1.png'
import IcedTea2 from './CategoryPage/Categories/Coffee/IcedTea2.jpg'
import IcedTea3 from './CategoryPage/Categories/Coffee/IcedTea3.jpg'
import IcedTea4 from './CategoryPage/Categories/Coffee/IcedTea4.png'
import IcedTea5 from './CategoryPage/Categories/Coffee/IcedTea5.jpg'
import MatchaTea1 from './CategoryPage/Categories/Coffee/MatchaTea1.jpg'
import MatchaTea2 from './CategoryPage/Categories/Coffee/MatchaTea2.jpg'
import MatchaTea3 from './CategoryPage/Categories/Coffee/MatchaTea3.jpg'
import MatchaTea4 from './CategoryPage/Categories/Coffee/MatchaTea4.jpg'
import SmoothiesHeroImage from './CategoryPage/Categories/Smoothies/Hero.jpg'
import Smoothie1 from './CategoryPage/Categories/Smoothies/Smoothie1.jpg'
import Smoothie2 from './CategoryPage/Categories/Smoothies/Smoothie2.jpg'
import Smoothie3 from './CategoryPage/Categories/Smoothies/Smoothie3.jpg'
import Smoothie4 from './CategoryPage/Categories/Smoothies/Smoothie4.jpg'
import Milkshake1 from './CategoryPage/Categories/Smoothies/Milkshake1.jpeg'
import Milkshake2 from './CategoryPage/Categories/Smoothies/Milkshake2.jpg'
import Milkshake3 from './CategoryPage/Categories/Smoothies/Milkshake3.jpg'
import Milkshake4 from './CategoryPage/Categories/Smoothies/Milkshake4.jpg'
import MocktailsHeroImage from './CategoryPage/Categories/Mocktails/Hero.jpg'
import Mocktail1 from './CategoryPage/Categories/Mocktails/Mocktail1.png'
import Mocktail2 from './CategoryPage/Categories/Mocktails/Mocktail2.jpeg'
import Mocktail3 from './CategoryPage/Categories/Mocktails/Mocktail3.jpg'
import Mocktail4 from './CategoryPage/Categories/Mocktails/Mocktail4.jpg'
import Mocktail5 from './CategoryPage/Categories/Mocktails/Mocktail5.jpg'
import Mocktail6 from './CategoryPage/Categories/Mocktails/Mocktail6.jpg'
import Juice1 from './CategoryPage/Categories/Mocktails/Juice1.jpg'
import Juice2 from './CategoryPage/Categories/Mocktails/Juice2.jpg'
import Juice3 from './CategoryPage/Categories/Mocktails/Juice3.jpg'
import Juice4 from './CategoryPage/Categories/Mocktails/Juice4.jpg'
import Juice5 from './CategoryPage/Categories/Mocktails/Juice5.jpg'
import SoftDrinksHeroImage from './CategoryPage/Categories/Soft Drinks/Hero.png'
import Water1 from './CategoryPage/Categories/Soft Drinks/Water1.jpg'
import Water2 from './CategoryPage/Categories/Soft Drinks/Water2.jpg'
import SoftDrink1 from './CategoryPage/Categories/Soft Drinks/SoftDrink1.jpg'
import SoftDrink2 from './CategoryPage/Categories/Soft Drinks/SoftDrink2.jpg'
import SoftDrink3 from './CategoryPage/Categories/Soft Drinks/SoftDrink3.jpeg'
import CateringService1 from './CateringPage/Service1.jpg'
import CateringService2 from './CateringPage/Service2.jpg'
import CateringService3 from './CateringPage/Service3.jpg'
import GalleryCategoryFood from './GalleryPage/Food.png'
import GalleryCategoryTeam from './GalleryPage/Team.png'
import GalleryCategoryInterior from './GalleryPage/Interior.png'

export const images = {
    Logo,
    LogoIcon,
    LogoBackground,
    NavBarBg,
    NavBarLarge,
    NavBarMobile,
    FooterLogo,
    FeatureCardLogo,
    Feature1,
    Feature2,
    Feature3,
    FeatureSectionShape,
    Category1,
    Category2,
    Category3,
    Category4,
    Category5,
    Category6,
    Category7,
    Category8,
    Category9,
    Category10,
    Category11,
    Category12,
    Category13,
    Category14,
    Category15,
    Category16,
    Category17,
    Category18,
    Category19,
    Category20,
    Category21,
    Category22,
    RatedProduct1,
    RatedProduct2,
    RatedProduct3,
    AboutHeroImage,
    Team,
    FavItem1,
    FavItem2,
    CategoryPageBackground,
    ArtisansHeroImage,
    Artisan1,
    Artisan2,
    Artisan3,
    Artisan4,
    Artisan5,
    BombolonesHeroImage,
    Bombolone1,
    Bombolone2,
    Bombolone3,
    BreakfastHeroImage,
    Breakfast1,
    Breakfast2,
    Breakfast3,
    CakesHeroImage,
    Cake1,
    Cake2,
    Cake3,
    CheesecakeHeroImage,
    Cheesecake1,
    Cheesecake2,
    ChilledDessertHeroImage,
    ChilledDessert1,
    ChilledDessert2,
    ChilledDessert3,
    ChilledDessert4,
    CookiesHeroImage,
    Cookie1,
    Cookie2,
    Cookie3,
    Cookie4,
    CupcakesHeroImage,
    Cupcake1,
    Cupcake2,
    Cupcake3,
    Cupcake4,
    Cupcake5,
    GrillsHeroImage,
    Grill1,
    Grill2,
    Grill3,
    PastaHeroImage,
    Pasta1,
    Pasta2,
    Pasta3,
    PiesTartsHeroImage,
    Pie1,
    Pie2,
    SaladsHeroImage,
    Salad1,
    Salad2,
    Salad3,
    SandwichesHeroImage,
    Sandwich1,
    Sandwich2,
    Sandwich3,
    SavoryPiesHeroImage,
    SavoryPie1,
    SavoryPie2,
    ViennoiserieHeroImage,
    Viennoiserie1,
    Viennoiserie2,
    Viennoiserie3,
    DanishPastriesHeroImage,
    DanishPastrie1,
    DanishPastrie2,
    DanishPastrie3,
    TresLechesHeroImage,
    TresLeches1,
    TresLeches2,
    TresLeches3,
    TresLeches4,
    TresLeches5,
    GelatoHeroImage,
    Gelato1,
    Gelato2,
    Gelato3,
    Gelato4,
    Gelato5,
    Gelato6,
    CoffeeHeroImage,
    HotCoffee1,
    HotCoffee2,
    HotCoffee3,
    HotCoffee4,
    HotCoffee5,
    HotCoffee6,
    HotCoffee7,
    HotCoffee8,
    HotCoffee9,
    HotCoffee10,
    HotCoffee11,
    HotCoffee12,
    HotTea1,
    HotTea2,
    HotTea3,
    HotTea4,
    HotTea5,
    HotTea6,
    HotTea7,
    ColdBrew1,
    ColdBrew2,
    IcedTea1,
    IcedTea2,
    IcedTea3,
    IcedTea4,
    IcedTea5,
    MatchaTea1,
    MatchaTea2,
    MatchaTea3,
    MatchaTea4,
    SmoothiesHeroImage,
    Smoothie1,
    Smoothie2,
    Smoothie3,
    Smoothie4,
    Milkshake1,
    Milkshake2,
    Milkshake3,
    Milkshake4,
    MocktailsHeroImage,
    Mocktail1,
    Mocktail2,
    Mocktail3,
    Mocktail4,
    Mocktail5,
    Mocktail6,
    Juice1,
    Juice2,
    Juice3,
    Juice4,
    Juice5,
    SoftDrinksHeroImage,
    Water1,
    Water2,
    SoftDrink1,
    SoftDrink2,
    SoftDrink3,
    CateringService1,
    CateringService2,
    CateringService3,
    GalleryCategoryFood,
    GalleryCategoryTeam,
    GalleryCategoryInterior,
}
